<!-- =========================================================================================
    File Name: Carousel.vue
    Description: Carousel demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

    <div id="extra-component-vue-awesome-swiper-demo">

          <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />
  
    <div id="demo-basic-card">
        <div class="vx-row">
            <div class="vx-col w-full sm:w-1/2 lg:w-1/4 mb-base" v-for="formation in formationT" >
                <vx-card>
                    <img :src="formation.image" alt="content-img" class="responsive rounded-lg">
                    <div class="my-6">
                        <h5 class="mb-2">{{ formation.titre }}</h5>
                        <p class="text-grey">{{ formation.description }}</p>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                        <span>
                            <p class="text-xl">{{ formation.prixx }}</p>
                            <p class="text-grey">{{ 'prix' }}</p>
                        </span>
                        <span>
                            <p class="text-xl">{{ 'domaine' }}</p>
                            <p class="text-grey">{{ formation.nom_domaine }}</p>
                        </span>
                    </div>
                    <vs-divider></vs-divider>
                    <div class="flex justify-between flex-wrap">
                        <vs-button class="mt-4 mr-2 shadow-lg" type="gradient" color="#7367F0" gradient-color-secondary="#CE9FFC" @click="inscri(formation.id)">Participer</vs-button>
                        <vs-button class="mt-4" type="border" color="#b9b9b9" @click="detaille(formation)">détails</vs-button>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
    
    </div>
    
</template>

<script>
import DataViewSidebar from './detaille.vue'
import moduleformation from '@/store/formation/moduleformation.js'
export default {
  components: {
     DataViewSidebar,
  },
  data() {
    return {
     addNewDataSidebar: false,
     sidebarData: {}
    }
  },
  computed: {
    formationT() {
      console.log(this.$store.state.formation.users)
      return this.$store.state.formation.users
    },
    
  },
  watch: {
   
    },
  methods: {
      inscri(id){
       
       this.$router.push('/formation/inscrie/' +id)
   },
    detaille(data) {
      console.log(data)
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
   toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    }, 
    
  },
  created() {
    if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
    this.$store.dispatch("formation/fetchUsers")
    
  },
  mounted() {
   
  }
}
</script>
<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}
</style>
